define('helper-misc-cloneObject',["exports"], function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function (o) {
        return Object.assign({}, o);
    };
});
